// extracted by mini-css-extract-plugin
export default {"container":"Login_container__ElFuJ","subContainer":"Login_subContainer__Ckxx5","loginHeading":"Login_loginHeading__WYWV-","signUpLink":"Login_signUpLink__bUFL-"};